import classnames from 'classnames'
import ActivityLoader from 'react-loaders'
import PropTypes from 'prop-types'

import classes from './Loader.module.scss'
import styles from '../../../assets/styles/globals.scss'

const Loader = ({ children }) => (
  <div className='d-flex flex-column align-items-center justify-content-center'>
    <ActivityLoader type='ball-pulse' color={styles.loaderAnimationGray} active />
    <span
      className={classnames('mt-3', classes.text)}
    >
      {children}
    </span>
  </div>
)

Loader.propTypes = {
  children: PropTypes.node,
}

export default Loader
